import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { LocationsService } from '../locations.service';
import { IPagedCountryResultRequestDto } from 'src/app/models/backend';
import { ControlItem } from 'src/app/models/frontend';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-create-location',
  templateUrl: './create-location.component.html',
  styleUrls: ['./create-location.component.scss']
})
export class CreateLocationComponent {
  errors: string[] | null = null;
  eventForm: FormGroup
  countries: any;
  countriesData: ControlItem[] = []

  request: IPagedCountryResultRequestDto = {
    isInvoledDeletedItems: false,
    skipCount: 0,
    maxResultCount: 1000
  };

  constructor(private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    public locationService: LocationsService,private toastr:ToastrService) {
    this.LoadCountries();
  }

  ngOnInit() {
    this.eventForm = this.fb.group({
      LocationCity: ['', [Validators.required, Validators.maxLength(100)]],
      LocationAddress: ['', [Validators.required, Validators.maxLength(100)]],
      PhoneNo: ['', [Validators.required, Validators.maxLength(100)]],
      CountryId: ['', [Validators.required, Validators.maxLength(10)]],
    });
  }
  onSubmit() {
    if (!this.eventForm.valid) return this.eventForm.markAllAsTouched();

    this.eventForm = this.fb.group({
      LocationCity: this.eventForm.value.LocationCity,
      LocationAddress: this.eventForm.value.LocationAddress,
      PhoneNo: this.eventForm.value.PhoneNo,
      CountryId: this.eventForm.value.CountryId,
    })
    console.log(this.eventForm.value)
    this.locationService.createLocation(this.eventForm.value)
      .subscribe({
        next: r => {
          // Swal.fire('Created', '', 'success')
          this.toastr.success('Created','Success')
          this.activeModal.close({ refresh: true });
        },
        error: e => 
          {
              if(this.errors = e.error?.errors || [e.error?.message])
              {
                this.toastr.error('Oops!', e.error.message);
              }
              else{
                this.toastr.error('Oops!', "Something went wrong");
  
              }
          }
      })

  }
  LoadCountries() {
    this.locationService.getCountries(this.request).subscribe((res: any) => {
      this.countries = res.items;
      for (let i = 0; i < this.countries.length; i++) {
        this.countriesData.push({label:this.countries[i].name,value:this.countries[i].id})
      }
    })
  }
  
}
